export default __webpack_public_path__ + "static/media/slide10.7c162017.jpg";